import { Product, ProductList } from '~/apps/pos/models';
import { currency } from '~/lib/formatters';
import { fieldType } from '~/apps/pos/mobile/containers/sales/CreateSale';
import { Decimal } from 'decimal.js';

type ProductForFormItem = {
  productType: string,
  productKey: string,
  productName: string,
  group: Array<{id: string, name: string}>,
  productValues: ProductList,
}

type ProductForFormList = Array<ProductForFormItem>

type productInitial = {
  [fieldName: string]: any,
}

const numberList = (count = 50): ProductList => {
  let res = [];
  for (let i = 0; i <= count; i++) {
    res.push({
      id: i,
      name: i,
      type: 'Item',
    })
  }

  return res;
};

const listYesNo = [
  {
    id: 0,
    name: 'No',
  },
  {
    id: 1,
    name: 'Yes',
  },
];

export class productType {
  static CUSTOM = 'Custom';
  static ITEM = 'Item';
  static ITEM_NOT_DROPDOWN = 'ItemNotDropdown';
  static SERVICE = 'Service';
}

export class adminFeeMode {
  static PERCENTAGE = 'percent';
  static ABSOLUTE = 'absolute';
}

export const serOrderArray = (arrayData: any): any => {
  if (!Array.isArray(arrayData)) return arrayData;

  return arrayData.map((i, ind) => ({ ...i, order: ind }))
};

export const sortByPropertyName = (arrayData: any, PropertyName = 'order'): any => {
  return arrayData.sort((a, b) => {
    return a[PropertyName] > b[PropertyName] ? 1 : a[PropertyName] < b[PropertyName] ? -1 : 0;
  })
};

export const parseFormData = (formData, prices: {[id: string]: Decimal}, administrativeFee: number, administrativeFeeMode: string, maxAmountsMode: boolean, maximumAmounts: Record<string, Decimal>): {
  resProducts: any, resSale: any, total: Decimal, grandTotal: Decimal, clearData: any
} => {
  let resProducts = {};
  let resSale = {};
  let clearData = {};
  let total: Decimal = new Decimal(0);

  const productItem = {
    productKey: null,
    productId: null,
    productType: null,
    price: 0,
    count: 0,
  };

  Object.keys(formData).forEach((fieldName) => {
    if (fieldName.search('group_') != -1) {
      clearData[fieldName] = '-';
      const totalItem: Decimal = !prices[formData[fieldName]] ? new Decimal(0) : new Decimal(prices[formData[fieldName]]);
      total = total.add(totalItem);

      resProducts = {
        ...resProducts,
        [fieldName]: {
          ...productItem,
          productKey: fieldName,
          productId: formData[fieldName],
          productType: productType.ITEM,
          price: totalItem,
          count: 1,
        }
      }
    } else if (fieldName.search('item_') != -1) {
      clearData[fieldName] = 0;
      const productId = fieldName.replace('item_', '');
      let totalItem: Decimal = !prices[productId] || !formData[fieldName] ? new Decimal(0) : new Decimal(prices[productId]).mul(formData[fieldName]);
      if (maxAmountsMode && Decimal.isDecimal(maximumAmounts[productId])
        && totalItem.cmp(maximumAmounts[productId]) === 1) {
        totalItem = maximumAmounts[productId];
      }
      total = total.add(totalItem);

      resProducts = {
        ...resProducts,
        [fieldName]: {
          ...productItem,
          productKey: fieldName,
          productType: productType.ITEM,
          productId,
          count: formData[fieldName],
          price: totalItem,
        }
      }
    } else if (fieldName.search('item-not-dropdown_') != -1) {
      clearData[fieldName] = 0;
      const productId = fieldName.replace('item-not-dropdown_', '');
      const formFieldIntValue = parseInt(formData[fieldName]);
      let totalItem: Decimal = !prices[productId] || !formFieldIntValue ? new Decimal(0) : new Decimal(prices[productId]).mul(formFieldIntValue);
      if (maxAmountsMode && Decimal.isDecimal(maximumAmounts[productId])
        && totalItem.cmp(maximumAmounts[productId]) === 1) {
        totalItem = maximumAmounts[productId];
      }
      total = total.add(totalItem);

      resProducts = {
        ...resProducts,
        [fieldName]: {
          ...productItem,
          productKey: fieldName,
          productType: productType.ITEM_NOT_DROPDOWN,
          productId,
          count: formFieldIntValue,
          price: totalItem,
        }
      }
    } else if (fieldName.search('service_') != -1) {
      clearData[fieldName] = 0;
      const productId = fieldName.replace('service_', '');
      const formFieldIntValue = parseInt(formData[fieldName]);
      const totalItem: Decimal = !prices[productId] || !formData[fieldName] ? new Decimal(0) : new Decimal(prices[productId]).mul(formFieldIntValue);
      total = total.add(totalItem);

      resProducts = {
        ...resProducts,
        [fieldName]: {
          ...productItem,
          productKey: fieldName,
          productType: productType.SERVICE,
          productId,
          count: formData[fieldName],
          price: totalItem,
        }
      }
    } else if (fieldName.search('custom_') != -1) {
      clearData[fieldName] = 0;
      const productId = fieldName.replace('custom_', '');
      const totalItem: Decimal = !parseFloat(formData[fieldName]) ? new Decimal(0) : new Decimal(parseFloat(formData[fieldName]));
      total = total.add(totalItem);

      resProducts = {
        ...resProducts,
        [fieldName]: {
          ...productItem,
          productKey: fieldName,
          productType: productType.CUSTOM,
          productId,
          count: 1,
          price: totalItem,
        }
      }
    } else {
      resSale = {
        ...resSale,
        [fieldName]: formData[fieldName],
      }
    }
  });

  var grandTotal = total;

  if (administrativeFee) {
    switch (administrativeFeeMode) {
      case adminFeeMode.ABSOLUTE:
        grandTotal = total.plus(administrativeFee / 100);
        break;
      default:
        grandTotal = total.mul(new Decimal(1).plus(administrativeFee / 100));
    }
  }

  return {
    resProducts,
    resSale,
    total,
    grandTotal,
    clearData,
  }
};

export const createFieldKey = (productItem: Product) => {
  if (productItem.group && typeof productItem.group === 'object' && productItem.group.id && productItem.group.name) {
    return `group_${productItem.group.id}`;
  } else {
    if (productItem.type === productType.ITEM) {
      return `item_${productItem.id}`
    } else if (productItem.type === productType.ITEM_NOT_DROPDOWN) {
      return `item-not-dropdown_${productItem.id}`
    } else if (productItem.type === productType.SERVICE) {
      return `service_${productItem.id}`
    } else if (productItem.type === productType.CUSTOM) {
      return `custom_${productItem.id}`
    }
  }
};

export const productPrices = (productsEntities): { [id: string]: Decimal } => {
  if (typeof productsEntities !== 'object') return {};

  return Object.keys(productsEntities).reduce((a, id) => {
    return {
      ...a,
      [id]: productsEntities[id].price,
    }
  }, {});
};

export const productMaximumAmounts = (productsEntities) => {
  if (typeof productsEntities !== 'object') return {};

  return Object.keys(productsEntities).reduce((a, id) => {
    return {
      ...a,
      [id]: productsEntities[id].maximumAmount,
    }
  }, {});
}

export const groupingProductForSaleForm = (
  products: ProductList,
  createInitialValue = false,
): ProductForFormList | productInitial => {

  if (!Array.isArray(products) || !products.length) return [];
  const result = [];
  let initialValues = {
    initial: true,
  };

  const _products = serOrderArray(products);

  const fillGroup = _products.filter((f: Product) => (!!f.group && typeof f.group === 'object' && f.group.id && f.group.name));
  const emptyGroup = _products.filter((f: Product) => (!f.group || typeof f.group !== 'object' || !f.group.id || !f.group.name));
  const productsCustom = emptyGroup.filter((f: Product) => (f.type === productType.CUSTOM));
  const productsService = emptyGroup.filter((f: Product) => (f.type === productType.SERVICE));
  const productsItem = emptyGroup.filter((f: Product) => (f.type === productType.ITEM));
  const productsItemNotDropdown = emptyGroup.filter((f: Product) => (f.type === productType.ITEM_NOT_DROPDOWN));

  const groupOrders = fillGroup.reduce((a, i) => {
    if (i.group && typeof a[i.group.id] === 'number') return a;

    return {
      ...a,
      [i.group.id]: i.order,
    }
  }, {});

  const groups = fillGroup.reduce((a, i: Product) => {
    return {
      ...a,
      [i.group.id]: {
        group: i.group,
        order: groupOrders[i.group.id],
      }
    }
  }, {});


  /**
   *  CREATE FIRST PRODUCTS INITIAL VALUE
   *
   *  if argument <createInitialValue === true>
   */

  if (createInitialValue) {
    Object.keys(groups).forEach((i) => {
      initialValues = {
        ...initialValues,
        [createFieldKey(groups[i])]: '-',
      };
    });

    productsItem.forEach((i) => {
      initialValues = {
        ...initialValues,
        [createFieldKey(i)]: 0,
      };
    });

    productsItemNotDropdown.forEach((i) => {
      initialValues = {
        ...initialValues,
        [createFieldKey(i)]: '0',
      };
    });

    productsService.forEach((i) => {
      initialValues = {
        ...initialValues,
        [createFieldKey(i)]: 0,
      };
    });

    productsCustom.forEach((i) => {
      initialValues = {
        ...initialValues,
        [createFieldKey(i)]: '0',
      };
    });

    return initialValues;
  }


  /**
   *  CREATE PRODUCTS FIELD DATA FOR FORM ELEMENTS
   *
   *  if argument <createInitialValue> default definition
   */

  Object.keys(groups).forEach((i) => {
    result.push({
      productType: 'GROUP',
      productKey: createFieldKey(groups[i]),
      productName: groups[i].group.name,
      group: groups[i],
      productValues: [{ id: '-', name: 'Select a Product' }].concat(fillGroup.filter(f => i === f.group.id)),
      order: groups[i].order,
    });
  });

  productsItem.forEach((i) => {
    result.push({
      productType: productType.ITEM,
      productKey: createFieldKey(i),
      productName: i.name,
      group: null,
      productValues: numberList(),
      order: i.order,
    });
  });

  productsItemNotDropdown.forEach((i) => {
    result.push({
      productType: productType.ITEM_NOT_DROPDOWN,
      productKey: createFieldKey(i),
      productName: i.name,
      group: null,
      productValues: [],
      order: i.order,
    });
  });

  productsService.forEach((i) => {
    result.push({
      productType: productType.SERVICE,
      productKey: createFieldKey(i),
      productName: i.name,
      group: null,
      productValues: listYesNo,
      order: i.order,
    });
  });

  productsCustom.forEach((i) => {
    result.push({
      productType: productType.CUSTOM,
      productKey: createFieldKey(i),
      productName: i.name,
      group: null,
      productValues: listYesNo,
      order: i.order,
      maximumAmount: i.maximumAmount,
    });
  });

  return sortByPropertyName(result);
};


export const createBodyData = (data, state) => {
  const {
    locationId, departmentId, shift, organizationId, description, poNumber, company, arrivalTime, checkInTime
  } = data.resSale;
  const { req, additionalFields } = state;
  const parseType = (item) => {
    switch (item.fieldType) {
      case fieldType.DECIMAL:
        return parseFloat(Number.parseFloat(req[item.id]).toFixed(2)) * 100;
      case fieldType.INT:
        return parseInt(req[item.id], 10);
      default:
        return req[item.id];
    }
  };
  const additionalData = !additionalFields.length ? {} : {
    additionalFields: additionalFields.reduce((a, i) => {
      return {
        ...a,
        [i.name]: parseType(i),
      }
    }, {})
  };

  let resProd = [];
  Object.keys(data.resProducts).forEach((i) => {
    if (data.resProducts[i].count && data.resProducts[i].price && !data.resProducts[i].price.equals(0)) {
      resProd.push({
        productId: data.resProducts[i].productId,
        quantity: data.resProducts[i].count,
        price: data.resProducts[i].price,
        // description: 'product description',
      });
    }
  }, []);

  return {
    poNumber: poNumber,
    arrivalTime,
    checkInTime,
    company: company,
    description: description,
    organizationId: organizationId,
    locationId: locationId,
    departmentId: departmentId || null,
    shift: shift || null,
    saleProducts: resProd,
    ...additionalData,
  }
};


/**
 *  OTHER
 */

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validatePhone = (phone) => {
  const re  = /^(\()?[2-9]{1}\d{2}(\))?(-|\s)?[2-9]{1}\d{2}(-|\s)\d{4}$/;
  return re.test(phone);
};
